export default function() {
  const { defaultAccountData } = this.getState()
  if (defaultAccountData) return Promise.resolve()
  return this.takeAction('reloadDefaultAccountData')
}
